import './DownloadPage.scss';

import React from 'react';

import Logo from 'components/Logo';
import PageContent from 'components/PageContent';

export default class DownloadPage extends React.Component {
    componentWillMount() {
        document.body.classList.add('download-page');
    }

    componentWillUnmount() {
        document.body.classList.remove('download-page');
    }

    render() {
        return (
            <PageContent>
                <Logo orientation="vertical" />
                Thank you for your interest in Zisk. Please download our app from the App Store or Google Play Store.
            </PageContent>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/DownloadPage/index.js